const LocalStorageHelper = {
	getUsername() {
		try {
			const obj = JSON.parse(localStorage.getItem('cso_app'));
			return obj.user._doc.name;
		} catch (e) { }
		return '';
	},
	getEmail() {
		try {
			const obj = JSON.parse(localStorage.getItem('cso_app'));
			return obj.user._doc.email;
		} catch (e) { }
		return '';
	},
	getUserId() {
		try {
			const obj = JSON.parse(localStorage.getItem('cso_app'));
			return obj.user._doc._id;
		} catch (e) { }
		return '';
	}
};

export default LocalStorageHelper;
